import Input from '@mui/material/Input';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import Select from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';
import { styled as withStyles } from '@mui/material/styles';
import { BrandColor } from 'constants/brandColor';

const OrangeCheckbox = withStyles({
  root: {
    color: BrandColor.ACCENT,
    '&$checked': {
      color: BrandColor.ACCENT
    }
  }
})(props => <Checkbox color="default" {...props} />);

function MultiSelect() {
  const [personName, setPersonName] = React.useState([]);
  const names = ['adsf', 'zxcv', 'qwer'];
  return (
    <FormControl>
      <InputLabel id="demo-mutiple-checkbox-label">Tag</InputLabel>
      <Select
        labelId="demo-mutiple-checkbox-label"
        id="demo-mutiple-checkbox"
        multiple
        value={personName}
        onChange={e => setPersonName(e.target.value)}
        input={<Input />}
        renderValue={selected => selected.join(', ')}
      >
        {names.map(name => (
          <MenuItem key={name} value={name}>
            <OrangeCheckbox checked={personName.indexOf(name) > -1} />
            <ListItemText primary={name} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

export default MultiSelect;
